// extracted by mini-css-extract-plugin
module.exports =  {"combos":"combos-TF23d","combo":"combo-i2l7g","separator":"separator-KiYac"};